import { SystemService } from "./SystemService";
import AuthService from "./AuthService";

class QuarriesService {
    systemService = null;
    api = null;
    authService = null;

    constructor() {
        this.systemService = new SystemService();
        this.authService = new AuthService();
        this.api = this.systemService.getApiAccess();
    }

    getQuarries() {
        let sessionId = this.authService.getSessionId();
        return this.api.get('quarries', { headers: { authorization: sessionId } });
    }

    getQuarryByWhCode(whCode) {
        let sessionId = this.authService.getSessionId();
        return this.api.get(`quarries/by-wh-code/${whCode}`, { headers: { authorization: sessionId } });
    }

    getQuarry(id) {
        let sessionId = this.authService.getSessionId();
        return this.api.get(`quarries/${id}`, { headers: { authorization: sessionId } });
    }

    createQuarry(quarry) {
        let sessionId = this.authService.getSessionId();
        return this.api.post('quarries', quarry, { headers: { authorization: sessionId } });
    }

    updateQuarry(id, quarry) {
        let sessionId = this.authService.getSessionId();
        return this.api.put(`quarries/${id}`, quarry, { headers: { authorization: sessionId } });
    }

    deleteQuarry(id) {
        let sessionId = this.authService.getSessionId();
        return this.api.delete(`quarries/${id}`, { headers: { authorization: sessionId } });
    }

    uploadMap(id, file, name) {
        let sessionId = this.authService.getSessionId();
        const formData = new FormData();
        formData.append('file', file);
        if (name) formData.append('name', name);
        return this.api.post(`quarries/${id}/upload-map`, formData, {
            headers: {
                'Content-Type': 'multipart/form-data',
                authorization: sessionId
            }
        });
    }

    addShelf(quarryId, shelf, quarryName) {
        let sessionId = this.authService.getSessionId();
        return this.api.post(`quarries/${quarryId}/shelves`, { shelf, quarryName }, { headers: { authorization: sessionId } });
    }

    updateShelf(shelfId, shelf) {
        let sessionId = this.authService.getSessionId();
        return this.api.put(`quarries/shelves/${shelfId}`, shelf, { headers: { authorization: sessionId } });
    }

    deleteShelf(shelfId) {
        let sessionId = this.authService.getSessionId();
        return this.api.delete(`quarries/shelves/${shelfId}`, { headers: { authorization: sessionId } });
    }
}

export default QuarriesService;
